export interface AuthUserState {
  uid: string;
  emailVerified: boolean;
}

export type AuthStateSubscriber = (
  next: (user: AuthUserState | null) => void,
  error: (error: unknown) => void,
) => () => void;

export function waitForVerifiedAuthUser(
  expectedUid: string,
  subscribe: AuthStateSubscriber,
  timeoutMs = 10_000,
): Promise<void> {
  return new Promise((resolve, reject) => {
    let settled = false;
    // Assigned after subscription because the subscriber may settle synchronously before returning cleanup.
    // eslint-disable-next-line prefer-const
    let unsubscribe: (() => void) | undefined;
    const timeout = setTimeout(() => {
      settled = true;
      unsubscribe?.();
      reject(new Error(`Verified Firebase auth user did not become ready within ${timeoutMs}ms`));
    }, timeoutMs);

    const finish = (error?: unknown) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      unsubscribe?.();
      if (error) {
        reject(error);
        return;
      }
      resolve();
    };

    unsubscribe = subscribe((user) => {
      if (user?.uid !== expectedUid || !user.emailVerified) return;
      finish();
    }, finish);

    if (settled) unsubscribe();
  });
}
